import { useState, useEffect } from 'react';
import {
    collection,
    query,
    where,
    onSnapshot
} from 'firebase/firestore';
import { db } from '../../Services/firebase-config';

export const useMentorResources = (mentorId, teamId) => {
    const [mentorResources, setMentorResources] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!teamId) {
            setMentorResources([]);
            setIsLoading(false);
            return;
        }

        let combinedResources = [];
        setIsLoading(true);

        // Query for admin resources
        const adminResourcesQuery = query(
            collection(db, "resources"),
            where("isAdminResource", "==", true)
        );

        // Set up real-time listener for admin resources
        const unsubscribeAdmin = onSnapshot(
            adminResourcesQuery,
            (snapshot) => {
                try {
                    const adminDocs = snapshot.docs.map(doc => ({
                        id: doc.id,
                        ...doc.data()
                    }));

                    console.log('Admin Resources:', adminDocs);
                    combinedResources = [
                        ...combinedResources.filter(r => !r.isAdminResource),
                        ...adminDocs
                    ];
                    setMentorResources(combinedResources);
                    setError(null);
                } catch (err) {
                    console.error('Error processing admin resources:', err);
                    setError(err.message);
                }
            }
        );

        let unsubscribeMentor = () => {};
        
        if (mentorId) {
            const mentorResourcesQuery = query(
                collection(db, "resources"),
                where("mentorId", "==", mentorId),
            );

            // Set up real-time listener for mentor resources
            unsubscribeMentor = onSnapshot(
                mentorResourcesQuery,
                (snapshot) => {
                    try {
                        const mentorDocs = snapshot.docs.map(doc => ({
                            id: doc.id,
                            ...doc.data()
                        }));

                        // Update combined resources while preserving admin resources
                        combinedResources = [
                            ...combinedResources.filter(r => r.isAdminResource),
                            ...mentorDocs.filter(r => r.visibility === 'public' || (r.allowedTeams && r.allowedTeams.includes(teamId)))
                        ];
                        setMentorResources(combinedResources);
                        setError(null);
                    } catch (err) {
                        console.error('Error processing mentor resources:', err);
                        setError(err.message);
                    } finally {
                        setIsLoading(false);
                    }
                }
            );
        } else {
            // If no mentorId, just set loading to false after admin resources are fetched
            setIsLoading(false);
        }

        return () => {
            unsubscribeAdmin();
            unsubscribeMentor();
        };
    }, [mentorId, teamId]);

    console.log('Mentor Resources:', mentorResources);

    return {
        mentorResources,
        isLoading,
        error
    };
};